import { useState, type JSX } from 'react'
import { useTranslation } from 'react-i18next'

import { IconButton } from '@ui/components/Button'
import { ListItem } from '@ui/components/List'
import { Popover, PopoverCard, PopoverList } from '@ui/components/Popover'
import { ArrowCircleIcon } from '@ui/icons/ArrowCircle.icon'
import { FileIcon } from '@ui/icons/File.icon'

interface Props {
  onDownload: (fileType?: string) => void
}

export const DownloadDropdown = ({ onDownload }: Props): JSX.Element => {
  const { t } = useTranslation()

  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  const handleDownload = (fileType: string) => {
    onDownload(fileType)
    setIsDropdownOpen(false)
  }

  const fileTypesToDownload = [
    { label: t('Excel File Type'), fileType: 'excel', icon: FileIcon },
    { label: t('PDF File Type'), fileType: 'pdf', icon: FileIcon },
    { label: t('CSV File Type'), fileType: 'csv', icon: FileIcon },
  ]

  return (
    <Popover
      direction='topRight'
      distance='0.5rem'
      isOpen={isDropdownOpen}
      setIsOpen={setIsDropdownOpen}
      content={
        <PopoverCard>
          <PopoverList>
            {fileTypesToDownload.map(({ label, fileType, icon }) => (
              <ListItem
                key={label}
                onClick={() => handleDownload(fileType)}
                startSlot={{ icon: icon }}
              >
                {label}
              </ListItem>
            ))}
          </PopoverList>
        </PopoverCard>
      }
    >
      <IconButton.Secondary
        size='md'
        icon={{ icon: ArrowCircleIcon.Down, color: 'text-med-em' }}
        onClick={() => setIsDropdownOpen(true)}
      />
    </Popover>
  )
}
